// @flow
import * as React from 'react';

type Props = {
  content: string,
  maxWidth: number,
  x: number,
  y: number,
  style: Object,
  fill: string
};

class TruncatingText extends React.Component<Props> {
  componentDidMount() {
    if (this.contentDiv && this.contentDiv.getBoundingClientRect) {
      const { height } = this.contentDiv.getBoundingClientRect();
      const fo = this.foreignObject;
      if (fo) {
        fo.setAttribute('height', `${height}`);
      }
    }
  }
  contentDiv = null;
  foreignObject = null;
  render() {
    const { x, y, style, fill, maxWidth, content } = this.props;
    return (
      <g className="WrappingTex">
        <switch>
          <foreignObject
            requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility"
            width={maxWidth}
            height="16"
            x={`${x}`}
            y={`${y}`}
            ref={foreignObject => {
              this.foreignObject = foreignObject;
            }}
          >
            <div
              style={{
                ...style,
                color: fill,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                maxWidth: `${maxWidth}px`
              }}
              ref={div => {
                this.contentDiv = div;
              }}
              title={content}
            >
              {content}
            </div>
          </foreignObject>
          <g width={maxWidth} overflow="hidden">
            <mask
              id="overflowMask"
              maskUnits="userSpaceOnUse"
              x="0"
              y="-16"
              width={maxWidth}
              height="80"
            >
              <rect x="0" y="-16" width={maxWidth} height="80" fill="white" />
            </mask>
            <text
              mask="url(#overflowMask)"
              x={`${x}`}
              y={`${y + 14}`}
              style={style}
              fill={fill}
            >
              <title>{content}</title>
              {content}
            </text>
          </g>
        </switch>
      </g>
    );
  }
}

export default TruncatingText;



// WEBPACK FOOTER //
// ./src/components/TruncatingText.jsx